import { render, staticRenderFns } from "./ManagePageActionsLayout.vue?vue&type=template&id=18e2ece4&"
import script from "./ManagePageActionsLayout.vue?vue&type=script&lang=js&"
export * from "./ManagePageActionsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports